import React from 'react';
import AppContainer from '../app-container';
import * as stageActions from '../../actions/stages';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import LocalizedStrings from '../../localization/strings';
import Loading from '../../components/loading';
import DocumentTitle from 'react-document-title';
import {isEnglish} from '../../localization/language-cookie';
import HtmlRenderer from '../../components/html-renderer';

class StagesPageContainer extends AppContainer {

    getRegulations(stage) {
        return isEnglish()
            ? stage.regulations_en
            : stage.regulations;
    }
    componentWillMount() {
        this.props.actions.fetchStage(this.props.params.itemId).then(this.handlePageResult.bind(this));
    }

    render() {
        const {stage} = this.props;
        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.stageRegulations)}>

                <div className="page-section">
                    <div className="container">
                        <h1 className="title">
                            <span>{stage.item.name}
                            </span>
                        </h1>
                        <h3 className="title">
                            <span>{LocalizedStrings.stageRegulations}
                            </span>
                        </h3>
                        {stage.loading
                            ? <Loading/>
                            : <div className="post-body">
                              <HtmlRenderer html={this.getRegulations(stage.item)}/>
                          </div>}

                    </div>
                </div>
            </DocumentTitle>
        )

    }
}
export default connect(function(state) {
    return {stage: state.stage.stage};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...stageActions
        }, dispatch)
    };
})(StagesPageContainer);



// WEBPACK FOOTER //
// ./src/js/containers/pages/stage-regulations-page-container.js